// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__eopYr","LogoDiv":"Header_LogoDiv__p3zal","HeaderText":"Header_HeaderText__cMbuE"};